import { normalizeMaterialSummaryJsonField } from './normalize-material-summary-json-field.util';

const ADDRESS_PART_KEYS = [
    'AddressLine1',
    'AddressLine2',
    'City',
    'StateOrProvince',
    'Country',
    'PostalCode',
] as const;

function addressPartString(value: unknown): string | null {
    if (value === null || value === undefined) {
        return null;
    }
    if (typeof value === 'string') {
        const t = value.trim();
        return t === '' ? null : t;
    }
    if (typeof value === 'number' && Number.isFinite(value)) {
        return String(value);
    }
    return null;
}

/**
 * One Excel cell for origin/destination facility address: joined components or legacy plain text.
 */
export function formatMaterialSummaryAddressForCell(value: unknown): string {
    const normalized = normalizeMaterialSummaryJsonField(value);
    if (normalized === undefined) {
        return '';
    }
    if (typeof normalized === 'string') {
        return normalized;
    }
    if (typeof normalized !== 'object' || normalized === null || Array.isArray(normalized)) {
        return '';
    }
    const o: Record<string, unknown> = normalized;
    const parts: string[] = [];
    for (const key of ADDRESS_PART_KEYS) {
        const part = addressPartString(o[key]);
        if (part !== null) {
            parts.push(part);
        }
    }
    return parts.join(', ');
}
